// @ts-check
import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"
import DefineBroadcast from "../broadcast/DefineBroadcast"
import { generateId } from "../broadcast/utils"

/**
 * @augments {Component<{context: BlockContext} & Broadcast_Action>}
 */
class DefineAction extends Component {
    static defaultProps = {
        tags: [],
    }
    componentWillMount() {
        const blockId = this.props.context.block.id

        const { name, tags, description, action } = this.props

        /**
         * @type {Broadcast_Action}
         */
        this.setState({
            id: generateId(blockId, "action", this.props.name),
            ownerBlockId: blockId,
            tags,
            name,
            description,
            channel: "action",
            action: action,
        })
    }

    // componentWillReceiveProps({ action }) {
    //     if (this.props.action !== action) {
    //         this.setState({ action, key: this.state.key + 1 })
    //         this.forceUpdate()
    //     }
    // }

    render() {
        return <DefineBroadcast broadcast={this.state} />
    }
}

DefineAction.propTypes = {}

export default function DefineActionInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <DefineAction {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/actions/DefineAction.js